import { EVENT_TYPES } from '../../common/constants'
import {
  renderSimpleUpdateEvent,
  renderTreeSaveEvent,
} from '../../common/helpers'

const renderLocationTypeEvent = event => {
  const { type } = event

  if (type === EVENT_TYPES.SAVE) {
    return renderTreeSaveEvent(event)
  }

  return renderSimpleUpdateEvent(event, 'name')
}

export default renderLocationTypeEvent
